import { OrganicEventSearchApiResponse } from '../../../../api/searchOrganicEvents';
import { useBaseEventsQuery } from './events';

const getOrganizerIdsFromEvents = (
    data: OrganicEventSearchApiResponse,
): string[] => {
    // Extract organizer IDs from primary_organizer_id
    const organizerIds = data.events.results
        .map((event) => event.primary_organizer_id)
        .filter(Boolean);

    // Deduplicate IDs
    return Array.from(new Set(organizerIds));
};

export const useOrganizerIdsInEvents = () =>
    useBaseEventsQuery<string[]>(
        getOrganizerIdsFromEvents,
        {},
        {
            optOutDedupeEvents: true,
        },
    );
